import React from "react";
import { RateAnalysis, QuoteRequest } from "../../types/rate-analysis";
import RefinanceComparisonReport from "./RefinanceComparisonReport";

interface RefinanceAnalysisResultsProps {
  analysis: RateAnalysis;
  quoteRequest: QuoteRequest;
  onRequestUpdate: () => void;
}

const RefinanceAnalysisResults: React.FC<RefinanceAnalysisResultsProps> = ({
  analysis,
  quoteRequest,
  onRequestUpdate,
}) => {
  return (
    <>
      {/* Quote Comparison Table */}
      <RefinanceComparisonReport
        analysis={analysis}
        quoteRequest={quoteRequest}
        gradeTitle="Your Refinance Options"
        onRequestUpdate={onRequestUpdate}
      />
    </>
  );
};

export default RefinanceAnalysisResults;
